import { render } from "./CompanyUsers.vue?vue&type=template&id=6d0ff4fa"
import script from "./CompanyUsers.vue?vue&type=script&lang=js"
export * from "./CompanyUsers.vue?vue&type=script&lang=js"

import "./CompanyUsers.vue?vue&type=style&index=0&id=6d0ff4fa&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__